import{P as i,V as o}from"./vendor-CStAXuG0.js";/* empty css                                       *//* empty css                                                  */const r=new o;r.init({ProductCard:i});
